// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// ***************************************************************** SalaryItems *******************************************************************
const INDEX_SALARY_ITEMS_PATTERN_SUCCESS = "INDEX_SALARY_ITEMS_PATTERN_SUCCESS";
const SHOW_SALARY_SUCCESS = "SHOW_SALARY_SUCCESS";
const STORE_SALARY_SUCCESS = "STORE_SALARY_SUCCESS";
const UPDATE_SALARY_ITEMS_SUCCESS = "UPDATE_SALARY_ITEMS_SUCCESS";
const DESTROY_SALARY_ITEMS_SUCCESS = "DESTROY_SALARY_ITEMS_SUCCESS";
// ******************************************************************** salaryItemRules **********************************************************************
const INDEX_SALARY_ITEMS_RULES_SUCCESS = "INDEX_SALARY_ITEMS_RULES_SUCCESS";
const SHOW_SALARY_ITEMS_RULE_SUCCESS = "SHOW_SALARY_ITEMS_RULE_SUCCESS";
const STORE_SALARY_ITEMS_RULE_SUCCESS = "STORE_SALARY_ITEMS_RULE_SUCCESS";
const UPDATE_SALARY_ITEMS_RULE_SUCCESS = "UPDATE_SALARY_ITEMS_RULE_SUCCESS";
const DESTROY_SALARY_ITEMS_RULE_SUCCESS = "DESTROY_SALARY_ITEMS_RULE_SUCCESS";

const INDEX_ASSIGNMENT_SALARY_SUCCESS = "INDEX_ASSIGNMENT_SALARY_SUCCESS";

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// ***************************************************************** SalaryItems *******************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexSuccess(payload) {
  return {
    type: INDEX_SALARY_ITEMS_PATTERN_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showSuccess(payload) {
  console.log("wefwef", payload);

  return {
    type: SHOW_SALARY_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showSuccessCustom(payload) {
  return {
    type: SHOW_SALARY_SUCCESS,
    payload: payload.data.geoFence,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeSuccess(payload) {
  return {
    type: STORE_SALARY_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _updateSuccess(payload) {
  return {
    type: UPDATE_SALARY_ITEMS_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {Number} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _destroySuccess(payload) {
  return {
    type: DESTROY_SALARY_ITEMS_SUCCESS,
    payload: payload,
  };
}

// ******************************************************************** salaryItemRules **********************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexSalaryItemRulesSuccess(payload) {
  return {
    type: INDEX_SALARY_ITEMS_RULES_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showSalaryItemRuleSuccess(payload) {
  return {
    type: SHOW_SALARY_ITEMS_RULE_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeSalaryItemRuleSuccess(payload) {
  return {
    type: STORE_SALARY_ITEMS_RULE_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _updateSalaryItemRuleSuccess(payload) {
  return {
    type: UPDATE_SALARY_ITEMS_RULE_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {Number} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _destroySalaryItemRuleSuccess(payload) {
  return {
    type: DESTROY_SALARY_ITEMS_RULE_SUCCESS,
    payload: payload,
  };
}


/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexSuccessAssignment(payload) {
  return {
    type: INDEX_ASSIGNMENT_SALARY_SUCCESS,
    payload: payload,
  };
}
// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// ***************************************************************** SalaryItems *******************************************************************
/**
 *
 * @param {Object} [params]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function index(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get("/SalaryItem/GetSalaryItems", { params })
      .then((r) => {
        // Add logging to debug response
        console.log('SalaryItems API Response:', r);
        dispatch(_indexSuccess(r));
        callback(false, r);
      })
      .catch((e) => {
        console.error('SalaryItems API Error:', e);
        callback(e);
      });
  };
}
/**
 *
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function indexSalary(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get("/ta/shifts", { params })
      .then((res) => {
        dispatch(_indexSuccessAssignment(res));
        console.log("ecsevwsv", res);
        callback(undefined, res);
      })
      .catch((err) => {
        app.error(
          err,
          "routes.home.attendance.shift",
          "ثبت درخواست شکست خورد",
          app.translate("routes.home.attendance.shift.Indexing Shifts Failed")
        );
        callback(err);
      });
  };
}
/**
 *
 * @param {Number} salaryItem
 * @param {Object} params
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function show(salaryItem, params = {}, callback = () => {}) {
  console.log("345345345334534534533453453453", salaryItem);

  return (dispatch, gs, api) => {
    api
      .get(`SalaryItem/GetSalaryItem/${salaryItem}`)
      .then((r) => {
        dispatch(_showSuccess(r));
        console.log("345345345334534534533453453453", r);

        callback(r);
      })
      .catch((e) => {});
  };
}

/**
 *
 * @param {Number} salaryItem
 * @param {Object} params
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function shows(salaryItem, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get(`/Ta/GeoFences/${salaryItem}`, { params })
      .then((r) => {
        dispatch(_showSuccessCustom(r));
        callback(r);
      })
      .catch((e) => {});
  };
}


/**
 *
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function store(data, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate(
        "routes.home.requests.pattern.salaryItems.Adding New SalaryItems"
      )
    );

    api
      .post("/SalaryItem/CreateSalaryItem", { data })
      .then((r) => {
        dispatch(_storeSuccess(r));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.requests.pattern.salaryItems.New SalaryItems Added Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.requests.salaryItems",
            "SalaryItems",
            app.translate(
              "routes.home.requests.pattern.salaryItems.Adding New SalaryItems Failed"
            )
          )
        );
      });
  };
}

/**
 *
 * @param {Number} salaryItem
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function update(salaryItem, data, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate("routes.home.requests.pattern.salaryItems.Updating SalaryItems")
    );

    api
      .put(`/SalaryItem/EditSalaryItem`, { data })
      .then((r) => {
        dispatch(_updateSuccess(r));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.requests.pattern.salaryItems.SalaryItems Updated Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.requests.salaryItems",
            "SalaryItems",
            app.translate(
              "routes.home.requests.pattern.salaryItems.Updating SalaryItems Failed"
            )
          )
        );
      });
  };
}

/**
 *
 * @param {Number} salaryItem
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function destroy(salaryItem, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate("routes.home.requests.pattern.salaryItems.Removing SalaryItems")
    );

    api
      .delete(`/SalaryItem/DeleteSalaryItem/${salaryItem}`)
      .then((r) => {
        dispatch(_destroySuccess(salaryItem));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.requests.pattern.salaryItems.SalaryItems Removed Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.requests.salaryItems",
            "SalaryItems",
            app.translate(
              "routes.home.requests.pattern.salaryItems.Removing SalaryItems Failed"
            )
          )
        );
      });
  };
}

/**
 *
 * @return {Function}
 */
export function emptySalaryItems() {
  return _indexSuccess({ data: { salaryItems: [] }, meta: {} });
}



// ******************************************************************** salaryItemRules **********************************************************************
/**
 *
 * @param {Object} [params]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function indexSalaryItemRules(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get("/rulePackRules", { params })
      .then((r) => {
        dispatch(_indexSalaryItemRulesSuccess(r));
        callback(r);
      })
      .catch((e) => {});
  };
}

/**
 *
 * @param {Number} salaryItemRule
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function showSalaryItemRule(
  salaryItemRule,
  params = {},
  callback = () => {}
) {
  return (dispatch, gs, api) => {
    api
      .get(`Salary/GetSalaryPatternDetail?id=${salaryItemRule}`, { params })
      .then((res) => {
        dispatch(_showSalaryItemRuleSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        callback(err);
      });
  };
}

/**
 *
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function storeSalaryItemRule(data, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate(
        "routes.home.requests.pattern.salaryItems.Adding New SalaryItems"
      )
    );

    api
      .put("/Salary/EditSalaryPatternDetailValues", { data })
      .then((r) => {
        dispatch(_storeSalaryItemRuleSuccess(r));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.requests.pattern.salaryItems.New SalaryItems Added Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.requests.salaryItems",
            "SalaryItems", 
            app.translate(
              "routes.home.requests.pattern.salaryItems.Adding New SalaryItems Failed"
            )
          )
        );
      });
  };
}

/**
 *
 * @param {Number} salaryItemRule
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function updateSalaryItemRule(salaryItemRule, data, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate(
        "routes.home.requests.pattern.salaryItems.Updating SalaryItems"
      )
    );

    api
      .put(`/requests/rules/packs/rules/${salaryItemRule}`, { data })
      .then((r) => {
        dispatch(_updateSalaryItemRuleSuccess(r));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.requests.pattern.salaryItems.SalaryItems Updated Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.requests.salaryItems",
            "SalaryItems",
            app.translate(
              "routes.home.requests.pattern.salaryItems.Updating SalaryItems Failed"
            )
          )
        );
      });
  };
}

/**
 *
 * @param {Number} salaryItemRule
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function destroySalaryItemRule(salaryItemRule, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate(
        "routes.home.requests.pattern.salaryItems.Removing SalaryItems"
      )
    );

    api
      .delete(`/requests/rules/packs/rules/${salaryItemRule}`)
      .then((r) => {
        dispatch(_destroySalaryItemRuleSuccess(salaryItemRule));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.requests.pattern.salaryItems.SalaryItems Removed Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.requests.salaryItems",
            "SalaryItems",
            app.translate(
              "routes.home.requests.pattern.salaryItems.Removing SalaryItems Failed"
            )
          )
        );
      });
  };
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptySalaryItem() {
  return _showSuccess({ data: { salaryItem: {} } });
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptySalaryItemRules() {
  return _indexSalaryItemRulesSuccess({
    data: { salaryItemRules: [] },
    meta: {},
  });
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptySalaryItemRule() {
  return _showSalaryItemRuleSuccess({ data: { salaryItemRule: {} } });
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {Object} state
 * @param {{type: String, payload: Object}} action
 * @return {Object}
 */
export default function reducer(
  state = {
    salaryItems: [],
    salaryItem: {},
    salaryItemRules: [],
    salaryItemRule: {},
    rule: {},
    metaSalaryItems: {},
    metaSalaryItemRules: {},
    shift: {},
  },
  action
) {
  let salaryItems;
  let salaryItem;
  let _index;
  let _meta;
 console.log('actsdfsdion', action);
 
  switch (action.type) {
    
    case INDEX_SALARY_ITEMS_PATTERN_SUCCESS:   
      console.log('Reducer INDEX_SALARY_ITEMS_PATTERN_SUCCESS:', action.payload);
      return Object.assign({}, state, {
        // Fix data mapping based on API response structure
        salaryItems: action.payload.data?.data || [],
        metaSalaryItems: action.payload.meta || {},
      });
    case SHOW_SALARY_SUCCESS:
      return Object.assign({}, state, {
        salaryItem: action.payload,
      });
    case STORE_SALARY_SUCCESS:
      salaryItems = app._.cloneDeep(state.salaryItems);
      salaryItems.push(action.payload);
      return Object.assign({}, state, {
        salaryItem: action.payload,
        salaryItems,
      });
    case UPDATE_SALARY_ITEMS_SUCCESS:
      salaryItems = app._.cloneDeep(state.salaryItems);
      salaryItem = app._.cloneDeep(state.salaryItem);
      _index = salaryItems?.findIndex(
        (_salaryItem) => _salaryItem.id === action.payload.id
      );
      salaryItems[_index] = action.payload;
      salaryItem.name = action?.payload?.name;
      salaryItem.description = action?.payload?.description;
      return Object.assign({}, state, {
        salaryItem,
        salaryItems,
      });
    case DESTROY_SALARY_ITEMS_SUCCESS:
      salaryItems = app._.cloneDeep(state.salaryItems);
      _index = salaryItems.findIndex(
        (_salaryItem) => _salaryItem.id === action.payload
      );
      salaryItems.splice(_index, 1);
      return Object.assign({}, state, {
        salaryItems,
        salaryItem: null,
        salaryItemRule: null,
      });
    case INDEX_SALARY_ITEMS_RULES_SUCCESS:
      return Object.assign({}, state, {
        salaryItemRules: action.payload.data.rulePackRules,
        metaSalaryItemRules: action.payload.meta,
      });
    case SHOW_SALARY_ITEMS_RULE_SUCCESS:
      return Object.assign({}, state, {
        salaryItemRule: action.payload,
      });
    case STORE_SALARY_ITEMS_RULE_SUCCESS:
      salaryItem = app._.cloneDeep(state.salaryItem);
      let _rules = [];
      _rules.push(action.payload);
      if (!app._.isEmpty(salaryItem.rules)) {
        _rules.push(...salaryItem.rules);
      }
      salaryItem.rules = _rules;
      return Object.assign({}, state, {
        salaryItemRule: action.payload,
        salaryItem,
      });
    case UPDATE_SALARY_ITEMS_RULE_SUCCESS:
      salaryItem = app._.cloneDeep(state.salaryItem);
      if (salaryItem?.rules) {
        _index = salaryItem.rules.findIndex(
          (_salaryItemRule) => _salaryItemRule.id === action.payload.id
        );
        salaryItem.rules[_index] = action.payload;
      }

      return Object.assign({}, state, {
        salaryItemRule: action.payload,
        salaryItem,
      });
    case DESTROY_SALARY_ITEMS_RULE_SUCCESS:
      salaryItem = app._.cloneDeep(state.salaryItem);
      _index = salaryItem.rules.findIndex(
        (_salaryItemRule) => _salaryItemRule.id === action.payload
      );
      salaryItem.rules.splice(_index, 1);
      return Object.assign({}, state, {
        salaryItem,
      });

    case INDEX_ASSIGNMENT_SALARY_SUCCESS:
      console.log("action.payloadsvsd", action.payload);
      _meta = action.payload.meta;
      return Object.assign({}, state, {
        shifts: action.payload,
        pagination: _meta
          ? app.pagination(_meta.currentPage + 1, _meta.total, _meta.limit)
          : {},
      });
    default:
      return state;
  }
}
